import { Link } from "react-router-dom";
import styled from "styled-components";

export const Sessao = styled.div`
  padding: 0 30px;
  width: 100%;
  margin-bottom: 20px;
  @media screen and (max-width: 414px) {
    padding: 0 24px;
  }
`;
export const Container = styled.div`
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const Card = styled(Link)`
  display: flex;
  background: rgba(0, 0, 0, 0.3);
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  text-decoration: none;
  width: 100%;
  min-width: 230px;
  height: 368px;
  padding: 50px 25px;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: 50px 15px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    z-index: -999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  p {
    font-size: 15px;
    color: #fff;
    font-weight: 400;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0;

    @media screen and (max-width: 1366px) {
      font-size: 13px;
    }
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 10px 0;
  h1 {
    font-weight: 500;
    font-size: 25px;
    color: #fff;
    margin-bottom: 10px;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;

    @media screen and (max-width: 1366px) {
      font-size: 20px;
    }
  }
  p {
    font-size: 10px;
    color: #fff;
    font-weight: 500;
  }
`;

export const TagsWrapper = styled.div`
  display: flex;
  gap: 5px;
`;

export const Tag = styled.div`
  min-width: 60px;
  padding: 0 5px;
  height: 23px;
  background: #071242;
  align-self: start;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: #071242;
    font-size: 10px;
    text-align: center;
    margin: 0;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
